export * from './index';



//////////////////
// WEBPACK FOOTER
// ./~/ng2-translate/ng2-translate.js
// module id = 133
// module chunks = 4